import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import i18n from './i18n'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  // linkExactActiveClass: 'active',
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/verify',
      name: 'verify',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verify.vue')
    },
    {
      path: '/:lang/please_verify',
      name: 'please_verify',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "demo" */ './views/Please_Verify.vue')
    },
    {
      path: '/reset',
      component: AuthLayout,
      children: [
        {
          path: '/',
          name: 'reset',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Reset.vue')
        }
      ]
    },
    {
      path: '/:lang',
      // redirect: 'dashboard',
      component: DashboardLayout,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["th"].includes(lang)) return next("th");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: '/:lang/dashboard',
          name: 'dashboard',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
        },
        {
          path: "/:lang/",
          name: 'home',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import("@/views/Dashboard.vue")
        },
        {
          path: '/:lang/billing',
          name: 'billing',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/Billing.vue')
        },
        {
          path: '/:lang/member',
          name: 'member',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/Member.vue')
        },
        {
          path: '/:lang/add_member',
          name: 'addmember',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/AddMember.vue')
        },
        {
          path: '/:lang/edit_member',
          name: 'editmember',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/EditMember.vue')
        },
        {
          path: '/:lang/profile',
          name: 'profile',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/Profile.vue')
        },
        {
          path: '/:lang/gyms',
          name: 'gyms',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/Gyms.vue')
        },
        {
          path: '/:lang/member_payment',
          name: 'member payment',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/MemberPayment.vue')
        },
        {
          path: '/:lang/checkin',
          name: 'checkin',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/Checkin.vue')
        },
        {
          path: '/:lang/history',
          name: 'history',
          meta: {
            requiresAuth: true,
            requiresGyms: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/History.vue')
        }
      ]
    },
    {
      path: '/:lang',
      // redirect: 'login',
      component: AuthLayout,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["th"].includes(lang)) return next("th");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: '/:lang/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/:lang/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue')
        },
        {
          path: '/:lang/forget',
          name: 'forget',
          component: () => import(/* webpackChunkName: "demo" */ './views/Forgetpassword.vue')
        },
        {
          path: '/:lang/addgym',
          name: 'addgym',
          meta: {
            requiresAuth: true,
            requiresActive: true
          },
          component: () => import(/* webpackChunkName: "demo" */ './views/Addgym.vue')
        }
      ]
    },
    {
      path: "*",
      redirect: "/th"
    },
    {
      path: '/:lang/logout',
      name: 'logout',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "demo" */ './views/Logout.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresGyms = to.matched.some(record => record.meta.requiresGyms)
  const requiresActive = to.matched.some(record => record.meta.requiresActive)
  if (requiresAuth) {
    if (store.state.token) {
      if (requiresActive) {
        // alert(store.state.profile.status)
        if (store.state.profile.status === 'active') {
          if (requiresGyms) {
            if (store.state.gyms) {
              next()
            } else {
              next('/'+i18n.locale+'/addgym')
            }
          } else {
            next()
          }
        } else {
          next('/'+i18n.locale+'/please_verify')
        }
      } else {
        next()
      }
    } else {
      next('/'+i18n.locale+'/login')
    }
  } else {
    next()
  }
}
)

export default router